module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "Whitney_Bell.53c114cc.webp";